import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-accordion__title" }
const _hoisted_2 = { class: "m-accordion__arrow" }
const _hoisted_3 = {
  class: "m-accordion__content",
  ref: "m-accordion__content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TpxHeading = _resolveComponent("TpxHeading")!
  const _component_TpxIcon = _resolveComponent("TpxIcon")!
  const _component_TpxParagraph = _resolveComponent("TpxParagraph")!
  const _component_ArrowLink = _resolveComponent("ArrowLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["m-accordion", [_ctx.colourClasses, _ctx.expanded ? 'm-accordion--expanded' : '']]),
    ref: "accordionRow"
  }, [
    _createElementVNode("button", {
      class: "m-accordion__heading",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_TpxHeading, {
          heading: _ctx.heading,
          level: 3
        }, null, 8, ["heading"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TpxIcon, {
          class: "m-accordion__icon",
          icon: _ctx.expanded ? 'chevron-up' : 'chevron-down',
          label: _ctx.expanded ? 'Arrow up' : 'Arrow down'
        }, null, 8, ["icon", "label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_TpxParagraph, {
        class: "m-accordion__text",
        content: _ctx.text
      }, null, 8, ["content"]),
      (_ctx.link)
        ? (_openBlock(), _createBlock(_component_ArrowLink, _mergeProps({
            key: 0,
            class: "m-accordion__link",
            underlineSpan: true
          }, _ctx.link, { tabindex: "-1" }), null, 16))
        : _createCommentVNode("", true)
    ], 512)
  ], 2))
}